export function InsightsLoadingState() {
  return (
    <div className="space-y-6" aria-busy="true" aria-label="Carregando dados de Insights">
      {/* KPI cards skeleton */}
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="animate-pulse rounded-lg border border-ink-700 bg-ink-850 px-5 py-4">
            <div className="h-2.5 w-24 rounded bg-ink-700" />
            <div className="mt-3 h-7 w-20 rounded bg-ink-700" />
          </div>
        ))}
      </div>

      {/* Chart skeletons */}
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="animate-pulse rounded-lg border border-ink-700 bg-ink-900 p-4">
            <div className="mb-3 h-2.5 w-40 rounded bg-ink-700" />
            <div className="h-44 rounded bg-ink-800" />
          </div>
        ))}
      </div>
    </div>
  );
}
